"use client";
import "react";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es18.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import r from "./index.es65.js";
r.div`
  .bl-select select[disabled] {
    background-color: var(--bl-c-sand-4);
    color: var(--bl-c-neutral-1);
  }
  .bl-select .bl-input {
    display: flex;
    align-items: center;
  }
`;
//# sourceMappingURL=index.es23.js.map
